import type { ComponentProps } from 'react';
import React from 'react';

import { useReorderIfRequired } from '../ReorderingScreen';
import { MenuCollectionScreenContent } from './subcomponents';

// ────────────────────────────────────────────────────────────────────────────────

export const MenuCollectionScreen = (props: MenuCollectionScreenProps) => {
  const { restaurantSlug } = props.route.params;

  useReorderIfRequired(restaurantSlug);

  return <MenuCollectionScreenContent {...props} />;
};

// ─── Types ──────────────────────────────────────────────────────────────────────

type MenuCollectionScreenProps = ComponentProps<
  typeof MenuCollectionScreenContent
>;
